// extracted by mini-css-extract-plugin
export var root = "_42b4a1a01301e1a482117913c481bff4-css";